import { format } from "date-fns";
import type { CSSProperties } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import { todayIso, type IsoDate } from "@budgeter/shared";
import { Button, Sheet } from "../../ui";

export interface DatePickerSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: IsoDate;
  onPick: (date: IsoDate) => void;
}

/** Domain dates are strings; DayPicker works in local-midnight Date objects. */
export function isoToLocalDate(date: IsoDate): Date {
  const [y, m, d] = date.split("-").map(Number);
  return new Date(y ?? 1970, (m ?? 1) - 1, d ?? 1);
}

export function localDateToIso(date: Date): IsoDate {
  return format(date, "yyyy-MM-dd");
}

export function DatePickerSheet({ open, onOpenChange, value, onPick }: DatePickerSheetProps) {
  const selected = isoToLocalDate(value);
  function choose(date: IsoDate) {
    onPick(date);
    onOpenChange(false);
  }
  return (
    <Sheet open={open} onOpenChange={onOpenChange} title="Date">
      <div className="flex flex-col items-center gap-3 pb-2">
        <DayPicker
          mode="single"
          required
          weekStartsOn={1}
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => d && choose(localDateToIso(d))}
          // The visible day number leads the name (axe label-content-name-mismatch).
          labels={{
            labelDayButton: (date, modifiers) =>
              `${format(date, "d MMMM yyyy, EEEE")}${modifiers.selected ? ", selected" : ""}${modifiers.today ? ", today" : ""}`,
          }}
          style={
            {
              "--rdp-accent-color": "var(--color-accent)",
              "--rdp-accent-background-color": "var(--color-accent-soft)",
              "--rdp-day-height": "44px",
              "--rdp-day-width": "44px",
              "--rdp-day_button-height": "42px",
              "--rdp-day_button-width": "42px",
            } as CSSProperties
          }
        />
        <Button variant="secondary" className="w-full" onClick={() => choose(todayIso())}>
          Today
        </Button>
      </div>
    </Sheet>
  );
}
